import React, { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import References from './index';
import './References.css';
import CustomTabListView from '../../components/common/CustomTabListView';

const ReferencesTabs = (props: any) => {
  const { tabs = [] } = props;

  return (
    <div className="references-wrapper">
      <CustomTabListView {...props} id={'references-tabs'}>
        {tabs.map((list: string) => {
          return (
            <Tab key={list} eventKey={list} title={list}>
              {list === 'References and Links' && <References />}
            </Tab>
          );
        })}
      </CustomTabListView>
    </div>
  );
};
export default ReferencesTabs;
